import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"

import { Button } from "@/components/ui/button"

import { M365ConnectionCard } from "../components/m365-connection-card"
import { m365ConnectionReturnPath } from "../utils/m365-connection"

export function M365ConnectionPage() {
  const { t } = useTranslation()
  // "Return" goes back where the user came from (e.g. the agent thread whose
  // pill linked here), not always to the roster. Only same-origin paths.
  const { search } = useLocation()
  const returnPath = m365ConnectionReturnPath(search, window.location.origin)
  return (
    <main className="mx-auto max-w-2xl space-y-4 p-6">
      <M365ConnectionCard />
      <Button asChild variant="outline">
        <Link data-testid="m365-connection-return" to={returnPath}>
          {t("agents.connection.return", { defaultValue: "Return" })}
        </Link>
      </Button>
    </main>
  )
}
